import './unit.scss'
import React, { useState, useEffect } from 'react'
import NavCircle from '@/component/nav/navCircle'
import Loading from '@/component/loading/loading'
import Question from '@/component/question/question'
//下面代码删掉会导致CacheVideoPlayer的视频样式出错，需要找时间解决下
import VideoPlayer from '@/component/video/videoPlayer'
import TVideoPlayer from '@/component/video/tVideoPlayer'
import CacheVideoPlayer from '@/component/video/cacheVideoPlayer'

import { get, post } from '@/api/http'
import { formatOssUrl } from '@/api/url'
import { useSearchParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { unitMap } from '@/data/unitMap'
import CourseNoticeModal from './component/courseNoticeModal'
const UnitPage = () => {
  const [unit, setUnit] = useState({})
  const [questions, setQuestions] = useState([])
  const [showLoading, setShowLoading] = useState(false)
  const [showCourseNotice, setShowCourseNotice] = useState(false)
  const [params] = useSearchParams()
  const navigate = useNavigate()

  const unitId = params.get('id')

  useEffect(() => {
    if (unitId) {
      const getQuestions = async (id) => {
        setShowLoading(true)
        const res = await post(`jq/v5/knowledge/category-ids`, {
          categoryIds: [id],
        })

        console.log('Questions res:', res)

        const questionIds =
          res?.filter((item) => item.type === 4 && item.isShow) ?? []

        const questionsList = await post(`jq/v5/questions/batch`, {
          ids: questionIds.map((item) => item.knowledgeId),
        })

        console.log('Questions list:', questionsList)

        setQuestions(questionsList)
        setShowLoading(false)
      }

      const getUnitInfo = async (id) => {
        const unitData = await get(
          `jq/v5/category/${unitMap[id] ?? id}?depth=0`
        )
        console.log('Unit info:', unitData)
        if (unitData) {
          setUnit(unitData)
          getQuestions(unitData.id)
        }
      }
      getUnitInfo(unitId)
    }
  }, [unitId])

  const courses = (unit.courses || []).sort((a, b) => b.createdAt - a.createdAt)
  const videoCourse = courses.find((item) => item.videoUrl?.length > 0)
  const pptCourse = courses.find((item) => item.pptUrl?.length > 0)

  const videoUrl = videoCourse ? formatOssUrl(videoCourse.videoUrl) : null
  const pptUrl = pptCourse ? formatOssUrl(pptCourse.pptUrl) : null
  const contactUrl = unit.contactUrl
  const hasContactUrl = Boolean(contactUrl)

  const hasQuestion = questions.length > 0

  const goBook = () => {
    navigate(`/pages/tiku/unit?bookId=${unit.parentId}`)
  }

  const goTest = () => {
    navigate(`/pages/exam/exam?id=${unit.id}`)
  }

  const goPpt = () => {
    if (!pptUrl) {
      return
    }
    localStorage.setItem('pptUrl', pptUrl)
    navigate(`/pages/ppt/index?url=${encodeURIComponent(pptUrl)}`)
  }

  const openCourseNotice = () => {
    setShowCourseNotice(true)
  }

  const closeCourseNotice = () => {
    setShowCourseNotice(false)
  }

  return (
    <div className="unit-page">
      <NavCircle buttonText="目录" onClick={goBook} />

      {videoUrl && <CacheVideoPlayer videoUrl={videoUrl}></CacheVideoPlayer>}

      {pptUrl && (
        <div className="ppt-entry" onClick={goPpt}>
          <div className="ppt-entry__content">
            <div className="ppt-entry__title">习题练习</div>
            <div className="ppt-entry__desc">点击开始闯关</div>
          </div>
          <div className="ppt-entry__arrow">→</div>
        </div>
      )}

      {hasContactUrl && (
        <div className="course-notice-card">
          <div className="course-notice-card__title">领取自然拼读训练营领</div>
          <div className="course-notice-card__tips">
            <div className="course-notice-card__tip">整体知识点梳理</div>
            <div className="course-notice-card__tip">本书学习规划</div>
            <div className="course-notice-card__tip">自然拼读学习重点讲解</div>
          </div>
          <button className="course-notice-btn" onClick={openCourseNotice}>
            <span className="course-notice-btn__text">课程领取通知</span>
            <span className="course-notice-btn__cta">立即领取</span>
            <span className="course-notice-btn__arrow">→</span>
          </button>
        </div>
      )}

      {hasContactUrl && (
        <CourseNoticeModal
          visible={showCourseNotice}
          onClose={closeCourseNotice}
          imageUrl={contactUrl}
        />
      )}

      {hasQuestion && (
        <div className="content">
          <div className="page-main-scroll">
            {showLoading && <Loading loadingText="获取题库中,请等待..." />}
            {!showLoading && (
              <div className="context-question">
                {questions.map((question, index) => (
                  <div className="question" key={'question' + index}>
                    <Question question={question} index={index} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {hasQuestion && (
        <div className="practice-btn" onClick={goTest}>
          练一练
        </div>
      )}
    </div>
  )
}

export default UnitPage
